<template>
  <div></div>
</template>

<script>
// 引入API
import {loginS2S} from "@/api/HttpService";

export default {
  data: function () {
    return {};
  },

  mounted: async function () {
    if (this.$route.query.sessionId) {
      localStorage.removeItem("sessionId");
      let params = {
        chlAppId: "com.brightcns.dxlc.wxmp",
        chlSid: this.$route.query.sessionId,
      };
      await loginS2S(params)
        .then(({ res }) => {
          if (
            res.originalData.bizCode == "SUCCESS" &&
            res.originalData.code == "SUCCESS"
          ) {
            window.localStorage.setItem("sessionId", res.data.sessionId);
            this.$router.replace({
              name: "DiscountHomePage",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  methods: {},
};
</script>

<style>
</style>
